import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

const ASSETS = import.meta.env.VITE_HEALTHCOM_ASSETS;

const verbiage = {
  continue: {
    es: 'Saltar demo para continuar',
    en: 'Skip demo to continue',
  },
  replay: {
    mobile: {
      es: 'Reproducir',
      en: 'Replay',
    },
    desktop: {
      es: 'Reproducir las instrucciones',
      en: 'Replay instructions',
    },
  },
};

type Props = {
  setInstructions: (arg: boolean) => void;
  language?: string;
  primaryColor: string;
};

const CCSInstructions: React.FC<Props> = ({ setInstructions, language, primaryColor }) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const [video, setVideo] = useState<string>();
  const [playing, setPlaying] = useState<boolean>(true);
  // const [show, setShow] = useState<boolean>(false);

  // useEffect(() => {
  //   setTimeout(
  //     () => {
  //       setShow(true);
  //     },
  //     process.env.NX_STAGE === 'local' ||
  //       process.env.NX_STAGE === 'dev' ||
  //       process.env.NX_STAGE === 'staging'
  //       ? 0
  //       : 16000
  //   );
  // });

  useEffect(() => {
    if (window.matchMedia('(max-width: 639px)').matches) {
      setVideo(`${ASSETS}/bodypicker-video-instructions-mobile.mp4`);
    } else {
      setVideo(`${ASSETS}/bodypicker-video-instructions-desktop.mp4`);
    }
  }, []);
  console.log({ video });

  return (
    // Full-viewport takeover. `fixed inset-0` (not `absolute h-screen`)
    // so the container actually covers the visible viewport regardless
    // of scroll position; with the prior `absolute` (no inset, anchored
    // to the document) the skip button at `bottom: 2%` of the container
    // landed below the fold whenever the survey page was scrollable.
    // z-[60] (not z-50) so we paint above the portal's BottomNav,
    // which is also `fixed z-50` and is rendered later in Container —
    // at equal z-indexes the bottom nav would obscure the skip/replay
    // controls anchored to the bottom of this overlay.
    <div className="fixed inset-0 z-[60] overflow-hidden bg-white">
      {/* Fill the fixed container exactly (absolute inset-0) so the
          absolutely-positioned skip/replay buttons below are anchored to
          the *visible* viewport. Previously this wrapper was content-sized
          by the ReactPlayer's height="100vh"; on iOS Safari/Chrome 100vh is
          the largest viewport (toolbars hidden), so `bottom: 2%` landed below
          the visible area behind the browser chrome and the skip button was
          unreachable. overflow-hidden on the parent clips the 100vh video. */}
      <div className="absolute inset-0">
        <ReactPlayer
          url={video}
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload',
              },
              forceVideo: true,
              forceHLS: video?.includes('.m3u8') && !isSafari,
            },
          }}
          playing={playing}
          playsinline
          width="100vw"
          height="100vh"
          onEnded={() => setPlaying(false)}
          className=""
          style={{ objectFit: 'cover' }}
        />
        {/* Demo watermark */}
        {/* <div className="z-10 bg-black bg-opacity-75 text-white px-6 py-3 rounded-lg text-2xl font-bold border-2 border-white shadow-lg absolute left-1/2 -translate-x-1/2 top-12">
          Demonstration in progress: <span className="text-red-500">Click continue to proceed</span>
        </div> */}
        <div
          style={{ position: 'absolute', right: '2%', bottom: '2%' }}
          className="instruction-bottom-right-button"
        >
          <button
            onClick={() => setInstructions(false)}
            className={[
              'cursor-pointer rounded-md shadow items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white hover:opacity-90 focus:outline-none focus:ring transition duration-150 ease-in-out mt-8',
            ].join(' ')}
            style={{
              backgroundColor: primaryColor,
            }}
            data-cy="continue-button"
          >
            {language === 'es' ? verbiage.continue.es : verbiage.continue.en}
          </button>
        </div>
        {!playing && (
          <div
            style={{ position: 'absolute', left: '2%' }}
            className="instruction-bottom-left-button"
          >
            <span className="flex gap-1 text-sm" onClick={() => setPlaying(true)}>
              <ArrowPathIcon className="h-5 w-5" />

              {video === `${ASSETS}/bodypicker-video-instructions-desktop.mp4`
                ? language === 'es'
                  ? verbiage.replay.desktop.es
                  : verbiage.replay.desktop.en
                : language === 'es'
                  ? verbiage.replay.mobile.es
                  : verbiage.replay.mobile.en}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CCSInstructions;
